import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { CurrencyRate } from '../entities/currency-rate';

@Injectable()
export class CurrencyRateService extends BaseCrudService<CurrencyRate> {

  public uri = '/api/currencyRate/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance CurrencyRateService');
  }

  buildSentence(entity?: CurrencyRate, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      
      query = query.concat(
        entity.currencyRateDate ?
          `currencyRateDate${QueryOperator.Equal}${entity.currencyRateDate.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.currencyType ?
          `currencyType.id${QueryOperator.Equal}${entity.currencyType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/currency-rate.service.ts